import { createElement, CSSProperties } from 'react';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { CrdValidationInput } from './CrdValidationInput';

export class CustomCrdQuestion extends SurveyQuestionElementBase {

	/**
	 * Get the SurveyJS question object
	 */
	get question() {
		return this.questionBase;
	}

	/**
	 * Get the current value
	 */
	get value(): string {
		return this.question?.value || '';
	}

	/**
	 * Returns container style based on read-only and design mode
	 */
	get containerStyle(): CSSProperties {
		const isDisabled = this.question.getPropertyValue('readOnly') || this.question.isDesignMode;
		return isDisabled ? { pointerEvents: 'none' as const } : {};
	}

	/**
	 * Handle input change from CrdValidationInput component
	 */
	handleChange = (value: string, exists: boolean, validationMessage?: string): void => {
		// Update the question value
		this.question.value = value;
		
		// Set survey variable for conditional visibility
		(this.question.survey as any)?.setVariable('isAlreadyExists', exists);
		
		// Save validation state for display mode restoration
		const questionName = this.question?.name;
		if (questionName && validationMessage) {
			const validationState = {
				isUnique: exists,
				validationMessage: validationMessage,
			};
			(this.question.survey as any)?.setValue(`_${questionName}_validation`, validationState, false);
		}
	};

	/**
	 * Get saved validation state from survey
	 */
	private getSavedValidationState(): { isUnique: boolean | null; validationMessage: string } | null {
		const questionName = this.question?.name;
		if (!questionName) return null;
		return (this.question?.survey as any)?.getValue(`_${questionName}_validation`) || null;
	}

	/**
	 * Render the CrdValidationInput component
	 */
	renderElement(): JSX.Element {
		const isDisabled = this.question.isReadOnly || this.question.isDesignMode;
		const isDisplayMode = (this.question.survey as any)?.mode === 'display';
		const placeholder = this.question.placeholder || 'Enter CRD/SEC Number';
		const savedValidation = this.getSavedValidationState();
		
		return (
			<div style={this.containerStyle}>
				{createElement(CrdValidationInput, {
					value: this.value,
					onChange: this.handleChange,
					placeholder,
					disabled: isDisabled,
					readOnly: isDisplayMode || isDisabled,
					initialValidationState: savedValidation,
				})}
			</div>
		);
	}
}

export const CustomCrdQuestionWrapper = CustomCrdQuestion;
